import {
    NinchatEventType,
    NinchatRealmJoinedEvent,
} from '../types/events'
import {
    NinchatState,
    NinchatStore,
} from 'api/types'
import {
    extractProperties,
    isEmpty,
} from './'
import {CaseReducer} from '@reduxjs/toolkit'

export const realmJoined: CaseReducer<NinchatState> = (state, action) => {
    const payload = Array.isArray(action.payload)
        ? action.payload.find((p) => p.event === NinchatEventType.NinchatRealmJoinedEvent)
        : action.payload

    const {
        realm_id,
        realm_attrs,
        realm_members,
        realm_settings,
        ...rest
    } = extractProperties<NinchatRealmJoinedEvent>(payload)

    isEmpty(rest)

    const _realm_members: NinchatStore.NinchatRealmMembersStore = {}

    for (const user_id of Object.keys(realm_members ?? {})) {
        const {
            user_attrs,
            ...realm_member
        } = realm_members?.[user_id] ?? {}

        if (user_id === state.user_id) {
            state.user_attrs = user_attrs ?? {}
        } else {
            state._users[user_id] ??= {} as NinchatStore.NinchatStoreUser
            state._users[user_id].user_attrs = user_attrs ?? {}
        }

        _realm_members[user_id] = realm_member
    }

    state.user_realms[realm_id] = {
        realm_attrs,
        realm_members,
        realm_settings,
    }
}
